module.exports = __webpack_public_path__ + "static/img_6530_optimized-3088d173bbfdccb604a3bafb56271023.jpg";